import testimonialsJson from './testimonials.json';
import Avatar1 from './avatars/Avatar1.svg';
import Avatar2 from './avatars/Avatar2.svg';
import Avatar3 from './avatars/Avatar3.svg';
import Avatar4 from './avatars/Avatar4.svg';

export type TestimonialBannerColor = 'blue' | 'yellow' | 'green' | 'purple';

export type Testimonial = {
  name: string;
  title: string;
  quote: string;
  bannerColor: TestimonialBannerColor;
  iconColor: string;
  avatarUrl: string;
  skillTag: string;
  causeTag: string;
};

const AVATAR_BY_KEY: Record<string, string> = {
  avatar1: Avatar1,
  avatar2: Avatar2,
  avatar3: Avatar3,
  avatar4: Avatar4,
};

export const TESTIMONIALS: Testimonial[] = (testimonialsJson as Testimonial[]).map(
  (entry) => ({
    ...entry,
    avatarUrl: AVATAR_BY_KEY[entry.avatarUrl] ?? entry.avatarUrl,
  }),
);
